module.exports = __webpack_public_path__ + "img/CM-SS-CA-Buick-Lifestyle.2fea5d11.jpeg";